// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modifications-form,
.modifications-form * {
    box-sizing: border-box;
}

.modifications-modal .modal-content {
    height: 760px;
    max-height: calc(100vh - 48px);
    overflow: visible;
}

.modifications-modal .modal-header {
    flex: 0 0 auto;
}

.modifications-modal .modal-body {
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
    border-radius: 0 0 var(--bs-modal-border-radius, 0.5rem) var(--bs-modal-border-radius, 0.5rem);
    background: #fff;
}

.modifications-form {
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
}

.modifications-form label {
    display: block;
    margin-bottom: 8px;
    color: inherit;
    font-weight: 400;
    text-transform: none;
}

.modifications-form .form-control,
.modifications-form .form-select {
    width: 100%;
    max-width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
}

.modifications-form input,
.modifications-form select {
    min-height: calc(1.5em + 0.75rem + 2px);
}

.modifications-form textarea {
    min-height: 95px;
    resize: vertical;
}

.modifications-device-list {
    max-height: 200px;
    overflow-y: auto;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.modifications-device-search {
    position: sticky;
    top: -8px;
    z-index: 1;
    padding: 8px;
    margin: -8px -8px 8px;
    background: #fff;
}

.modifications-device-search input {
    border-radius: 10px !important;
}

.modifications-device-option {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.modifications-device-status {
    padding: 12px 8px;
    color: #6c7d90;
    text-align: center;
}

.modifications-form .mb-3 {
    margin-bottom: 16px !important;
}

.modifications-actions {
    display: flex;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 16px;
}

.modifications-actions button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

.modifications-primary-button,
.modifications-primary-button:hover,
.modifications-primary-button:focus,
.modifications-primary-button:active {
    background-color: #006699 !important;
    border-color: #006699 !important;
    color: #fff !important;
}

.modifications-primary-button:disabled {
    background-color: #ccc !important;
    border-color: #ccc !important;
    color: #fff !important;
    cursor: not-allowed;
}

@media (max-width: 576px) {
    .modifications-modal .modal-content {
        height: calc(100vh - 24px);
        max-height: calc(100vh - 24px);
    }

    .modifications-actions { flex-direction: column; }
    .modifications-actions button { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/modificaciones.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,8FAA8F;IAC9F,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;;;;IAII,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA,yBAAyB,sBAAsB,EAAE;IACjD,gCAAgC,WAAW,EAAE;AACjD","sourcesContent":[".modifications-form,\n.modifications-form * {\n    box-sizing: border-box;\n}\n\n.modifications-modal .modal-content {\n    height: 760px;\n    max-height: calc(100vh - 48px);\n    overflow: visible;\n}\n\n.modifications-modal .modal-header {\n    flex: 0 0 auto;\n}\n\n.modifications-modal .modal-body {\n    min-height: 0;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    scrollbar-gutter: stable;\n    border-radius: 0 0 var(--bs-modal-border-radius, 0.5rem) var(--bs-modal-border-radius, 0.5rem);\n    background: #fff;\n}\n\n.modifications-form {\n    width: 100%;\n    max-width: 720px;\n    margin: 0 auto;\n}\n\n.modifications-form label {\n    display: block;\n    margin-bottom: 8px;\n    color: inherit;\n    font-weight: 400;\n    text-transform: none;\n}\n\n.modifications-form .form-control,\n.modifications-form .form-select {\n    width: 100%;\n    max-width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n}\n\n.modifications-form input,\n.modifications-form select {\n    min-height: calc(1.5em + 0.75rem + 2px);\n}\n\n.modifications-form textarea {\n    min-height: 95px;\n    resize: vertical;\n}\n\n.modifications-device-list {\n    max-height: 200px;\n    overflow-y: auto;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.modifications-device-search {\n    position: sticky;\n    top: -8px;\n    z-index: 1;\n    padding: 8px;\n    margin: -8px -8px 8px;\n    background: #fff;\n}\n\n.modifications-device-search input {\n    border-radius: 10px !important;\n}\n\n.modifications-device-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.modifications-device-status {\n    padding: 12px 8px;\n    color: #6c7d90;\n    text-align: center;\n}\n\n.modifications-form .mb-3 {\n    margin-bottom: 16px !important;\n}\n\n.modifications-actions {\n    display: flex;\n    justify-content: center;\n    gap: 0.75rem;\n    margin-top: 16px;\n}\n\n.modifications-actions button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.modifications-primary-button,\n.modifications-primary-button:hover,\n.modifications-primary-button:focus,\n.modifications-primary-button:active {\n    background-color: #006699 !important;\n    border-color: #006699 !important;\n    color: #fff !important;\n}\n\n.modifications-primary-button:disabled {\n    background-color: #ccc !important;\n    border-color: #ccc !important;\n    color: #fff !important;\n    cursor: not-allowed;\n}\n\n@media (max-width: 576px) {\n    .modifications-modal .modal-content {\n        height: calc(100vh - 24px);\n        max-height: calc(100vh - 24px);\n    }\n\n    .modifications-actions { flex-direction: column; }\n    .modifications-actions button { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
